export { default } from './risk-tolerance';
